import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"
import { PAGINATION_INITIAL_STATE } from "./constants"

// ============ LIST ADD-ONS ============
const requested = createAction("addOns/requested")
const received = createAction("addOns/received")
const failed = createAction("addOns/failed")

// ============ GET SINGLE ADD-ON ============
const requestedAddOn = createAction("addOns/requestedAddOn")
const receivedAddOn = createAction("addOns/receivedAddOn")
const failedAddOn = createAction("addOns/failedAddOn")

// ============ CREATE ============
const requestedCreateAddOn = createAction("addOns/requestedCreateAddOn")
const receivedCreateAddOn = createAction("addOns/receivedCreateAddOn")
const failedCreateAddOn = createAction("addOns/failedCreateAddOn")

// ============ UPDATE ============
const requestedUpdateAddOn = createAction("addOns/requestedUpdateAddOn")
const receivedUpdateAddOn = createAction("addOns/receivedUpdateAddOn")
const failedUpdateAddOn = createAction("addOns/failedUpdateAddOn")

// ============ DELETE ============
const requestedDeleteAddOn = createAction("addOns/requestedDeleteAddOn")
const receivedDeleteAddOn = createAction("addOns/receivedDeleteAddOn")
const failedDeleteAddOn = createAction("addOns/failedDeleteAddOn")

// ============ ASSOCIATED EXPERIENCES ============
const requestedAssociatedExperiences = createAction("addOns/requestedAssociatedExperiences")
const receivedAssociatedExperiences = createAction("addOns/receivedAssociatedExperiences")
const failedAssociatedExperiences = createAction("addOns/failedAssociatedExperiences")

const initialState = {
  ...LOADING_INITIAL_STATE,
  items: [],
  metadata: PAGINATION_INITIAL_STATE,
  addOn: { ...LOADING_INITIAL_STATE, data: null },
  createAddOn: { ...LOADING_INITIAL_STATE, data: null },
  updateAddOn: { ...LOADING_INITIAL_STATE, data: null },
  deleteAddOn: { ...LOADING_INITIAL_STATE, data: null },
  associatedExperiences: { ...LOADING_INITIAL_STATE, data: [] }
}

const addOnsReducer = createReducer(initialState, {
  [requested.type]: (state) => setRequested(state),
  [received.type]: (state, { payload }) => {
    setReceived(state)
    state.items = payload.data || payload
    if (payload.metadata) Object.assign(state.metadata, payload.metadata)
  },
  [failed.type]: (state) => setFailed(state),

  [requestedAddOn.type]: (state) => setRequested(state.addOn),
  [receivedAddOn.type]: (state, { payload }) => {
    setReceived(state.addOn)
    state.addOn.data = payload.data || payload
  },
  [failedAddOn.type]: (state) => setFailed(state.addOn),

  [requestedCreateAddOn.type]: (state) => setRequested(state.createAddOn),
  [receivedCreateAddOn.type]: (state) => setReceived(state.createAddOn),
  [failedCreateAddOn.type]: (state) => setFailed(state.createAddOn),

  [requestedUpdateAddOn.type]: (state) => setRequested(state.updateAddOn),
  [receivedUpdateAddOn.type]: (state) => setReceived(state.updateAddOn),
  [failedUpdateAddOn.type]: (state) => setFailed(state.updateAddOn),

  [requestedDeleteAddOn.type]: (state) => setRequested(state.deleteAddOn),
  [receivedDeleteAddOn.type]: (state) => setReceived(state.deleteAddOn),
  [failedDeleteAddOn.type]: (state) => setFailed(state.deleteAddOn),

  [requestedAssociatedExperiences.type]: (state) => {
    setRequested(state.associatedExperiences)
    state.associatedExperiences.data = []
  },
  [receivedAssociatedExperiences.type]: (state, { payload }) => {
    setReceived(state.associatedExperiences)
    state.associatedExperiences.data = payload.data || payload
  },
  [failedAssociatedExperiences.type]: (state) => setFailed(state.associatedExperiences)
})

export default addOnsReducer

// ============ API ACTIONS ============

export const getAddOns = (params = {}) =>
  api({
    url: "/guide/settings/add_ons",
    method: "get",
    params,
    onStart: requested.type,
    onSuccess: received.type,
    onError: failed.type
  })

export const getAddOn = (id) =>
  api({
    url: `/guide/settings/add_ons/${id}`,
    method: "get",
    onStart: requestedAddOn.type,
    onSuccess: receivedAddOn.type,
    onError: failedAddOn.type
  })

// `data` is a FormData (the photo file is optional) wrapping `add_on[...]` keys.
export const createAddOn = (data) =>
  api({
    url: "/guide/settings/add_ons",
    method: "post",
    data,
    onStart: requestedCreateAddOn.type,
    onSuccess: receivedCreateAddOn.type,
    onError: failedCreateAddOn.type,
    showSuccessNotification: true
  })

export const updateAddOn = (id, data) =>
  api({
    url: `/guide/settings/add_ons/${id}`,
    method: "put",
    data,
    onStart: requestedUpdateAddOn.type,
    onSuccess: receivedUpdateAddOn.type,
    onError: failedUpdateAddOn.type,
    showSuccessNotification: true
  })

export const deleteAddOn = (id) =>
  api({
    url: `/guide/settings/add_ons/${id}`,
    method: "delete",
    onStart: requestedDeleteAddOn.type,
    onSuccess: receivedDeleteAddOn.type,
    onError: failedDeleteAddOn.type,
    props: { id },
    showSuccessNotification: true
  })

export const getAddOnAssociatedExperiences = (id) =>
  api({
    url: `/guide/settings/add_ons/${id}/associated_trips`,
    method: "get",
    onStart: requestedAssociatedExperiences.type,
    onSuccess: receivedAssociatedExperiences.type,
    onError: failedAssociatedExperiences.type
  })
